import service from './Setting'




export const GetStationList = (id,page) => service.get(`/Station/ListStation?customer_row_id=${id}&page_index=${page}`);
